/* eslint-env browser */
require('./polyfills')
const { initSentry } = require('../../client/clientjs/services/sentry-service')
initSentry()

const DomHelper = require('../../client/clientjs/dom-helper')
const ModalsHelper = require('../../client/clientjs/utils/modals')
const analyticsService = require('./analytics')

function openModal(modal) {
  ModalsHelper.open(modal)
}

function closeModal(modal) {
  ModalsHelper.close(modal)
}

DomHelper.onDocumentReady(() => {
  // auto bind all links with data-analytics-event to an GA event
  const links = DomHelper.queryAll('[data-analytics-event]')
  links.forEach(elt => {
    const dataLabel = DomHelper.data(elt, 'analytics-event')
    elt.onclick = analyticsService.trackEvent(dataLabel)
  })
  const linksSimple = DomHelper.queryAll('[data-analytics-event-simple]')
  linksSimple.forEach(elt => {
    const dataLabel = DomHelper.data(elt, 'analytics-event-simple')
    elt.onclick = analyticsService.trackEventSimple(dataLabel)
  })

  // auto bind all load images with data-onload-analytics-event to an GA event
  const images = DomHelper.queryAll('[data-onload-analytics-event]')
  images.forEach(elt => {
    const dataLabel = DomHelper.data(elt, 'onload-analytics-event')
    elt.onload = analyticsService.trackView(dataLabel)
  })

  // modals
  const modalsOpener = DomHelper.queryAll('[data-open-modal]')
  modalsOpener.forEach(opener => {
    opener.onclick = function(e) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      // close previously active modal
      DomHelper.queryAll('.modal.active').forEach(eltToClose => {
        closeModal(eltToClose)
      })

      const targetElts = DomHelper.queryAll(`#${DomHelper.data(opener, 'open-modal')}`)
      if (targetElts.length > 0) {
        const targetElt = targetElts[0]
        openModal(targetElt)
      }
      return false
    }
  })

  const modals = DomHelper.queryAll('.modal')
  modals.forEach(function(modal) {
    const overlay = DomHelper.query(modal, '.modal-overlay')
    const background = DomHelper.query(modal, '.modal-background')
    if (overlay || background) {
      const hideOnOverlayClick = DomHelper.data(modal, 'hide-modal-on-overlay-click')
      if (hideOnOverlayClick) {
        ;(overlay || background).onclick = function() {
          closeModal(modal)
        }
      } else {
        ;(overlay || background).onclick = null
      }
    }
  })

  const modalsCloser = DomHelper.queryAll('[data-close-modal]')
  modalsCloser.forEach(closer => {
    closer.onclick = function() {
      const targetElts = DomHelper.queryAll(`#${DomHelper.data(closer, 'close-modal')}`)
      if (targetElts.length > 0) {
        const targetElt = targetElts[0]
        closeModal(targetElt)
      }
    }
  })

  // sliders
  const sliders = DomHelper.queryAll('.slider')
  sliders.forEach(slider => {
    const labels = DomHelper.queryAll(slider, 'label')
    labels.forEach(label => {
      const forId = label.getAttribute('for')
      label.onclick = function() {
        const activeLabels = DomHelper.queryAll(slider, 'label')
        activeLabels.forEach(activeLabel => {
          DomHelper.removeClass(activeLabel, 'active')
        })
        DomHelper.addClass(label, 'active')
        DomHelper.queryAll(slider, '.image-container .active').forEach(container => {
          DomHelper.removeClass(container, 'active')
        })
        const targets = DomHelper.queryAll(slider, `#${forId}`)
        if (targets.length > 0) {
          DomHelper.addClass(targets[0], 'active')
        }
      }
    })
  })

  const clickedDropDowns = DomHelper.queryAll('[data-dropdown-target]')
  clickedDropDowns.forEach(clickedDropDown => {
    clickedDropDown.onclick = function() {
      const targetElt = DomHelper.query(`#${DomHelper.data(clickedDropDown, 'dropdown-target')}`)
      if (targetElt) {
        DomHelper.toggleClass(targetElt, 'active')
      }
    }
  })
})
